/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SuspectedTradeUserLoader_item = {
    readonly vertical: VerticalType | null;
    readonly " $refType": "SuspectedTradeUserLoader_item";
};
export type SuspectedTradeUserLoader_item$data = SuspectedTradeUserLoader_item;
export type SuspectedTradeUserLoader_item$key = {
    readonly " $data"?: SuspectedTradeUserLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspectedTradeUserLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'e0429a3bc313f2074497a94adccd3cac';
export default node;
